type ServiceName =
  | 'CB'
  | 'CONECS'
  | 'CASH'
  | 'PRINTER_RECEIPT'
  | 'PRINTER_DOCUMENT'
  | 'PRINTER_LABEL';

export enum NumberParameterName {
  ConecsMaxAmount = 'ConecsMaxAmount',
  CashMaxAmount = 'CashMaxAmount',
  CashMaxAmountDispensable = 'CashMaxAmountDispensable',
}

export enum BooleanParameterName {
  CB = 'CB',
  CONECS = 'CONECS',
  CASH = 'CASH',
  PRINTER_RECEIPT = 'PRINTER_RECEIPT',
  PRINTER_DOCUMENT = 'PRINTER_DOCUMENT',
  PRINTER_LABEL = 'PRINTER_LABEL',
}

export interface MoneylineStatusResponse {
  Services: Array<{
    Name: ServiceName;
    Status: string;
    Message: string;
  }>;
}

export type Status = {
  [name in ServiceName]?: boolean;
} & {
  errors: {
    [name in ServiceName]?: string;
  };
};

export interface MoneylineConfigurationResponse {
  Parameters: Array<{
    Name: NumberParameterName | BooleanParameterName;
    Value: string;
  }>;
}

export type Configuration = {
  [name in NumberParameterName]?: number;
} &
  {
    [name in BooleanParameterName]?: boolean;
  };

export interface MoneylineTicketStepFeedline {
  action: 'feedline';
  attributes: [string];
  value: '';
}

export interface MoneylineTicketStepLine {
  action: 'line';
  attributes: [
    'center' | 'left' | 'right',
    '0' | '1',
    '0' | '1',
    '0' | '1' | '2' | '3',
  ];
  value: string;
}

export interface MoneylineTicketStepBarcode {
  action: 'Barcode';
  attributes: [];
  value: string;
}

export type MoneylineTicketLine =
  | MoneylineTicketStepFeedline
  | MoneylineTicketStepLine
  | MoneylineTicketStepBarcode;

export interface LineParams {
  align?: 'center' | 'left' | 'right';
  bold?: boolean;
  underline?: boolean;
  size?: '0' | '1' | '2' | '3';
  value: string;
}

export type BarcodeParam = string;

export type FeedlineParam = number;

export type CreateTicketLineParam = FeedlineParam | LineParams | BarcodeParam;

export type LineType = 'feedline' | 'line' | 'barCode';

export interface MoneylineTicketPayload {
  Content: Array<MoneylineTicketLine>;
}

export type MoneylineSuccessResponse<T> = (
  | {
      State: 'OK';
    }
  | {
      Result: 'OK';
    }
  | {}
) & { ApiException: null } & T;

export type MoneylineResponse<T> =
  | MoneylineSuccessResponse<T>
  | {
      State?: 'KO';
      Result?: 'KO';
      ApiException: string;
    };
